// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"az_Xlc","headerTitle":"az_Ylc","backButton":"az_Zlc","backIcon":"az__lc","closeIcon":"az_amc"};